import React, { Component } from "react";
import styles from "./trips.module.scss";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import Scrollbars from "react-custom-scrollbars-2";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { NavLink } from "react-router-dom";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import getDates from "../../../shared/services/date.service";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { getDaysWeekString } from "../AlarmTools/LogisticDaysWeekService";
import { withAuth } from "../../../shared/containers/containerAuth";

class TripsList extends Component {
  constructor(props) {
    super(props);

    this.state = { deleteTrip: null, isDeleteModalOpen: false };
  }

  onChangeClick(trip) {
    const { onSetViewPanel, viewPanelItems } = this.props;
    onSetViewPanel(viewPanelItems.createTrip);
  }

  onDelete(trip) {
    const { onDeleteLogisticTrip } = this.props;

    onDeleteLogisticTrip(trip);
  }

  onCopyTrip(trip, index) {
    const { onCopyLogisticTrip } = this.props;
    onCopyLogisticTrip(trip, index + 1);
  }

  render() {
    const { logisticTrips, data } = this.props;
    const { deleteTrip, isDeleteModalOpen } = this.state;

    const height = window.innerHeight > 800 ? 650 : 450;

    const tripGetPermission = data.permissions.includes(29005);
    const tripDeletePermission = data.permissions.includes(29002);
    const tripCopyPermission = data.permissions.includes(29006);

    return (
      <div className={styles.tripsListContainer}>
        <div className={styles.tripListTable}>
          <div className={styles.tripListHeaderTable}>
            <div></div>
            <div>Наименование</div>
            <div>Описание</div>
            <div>Наименование ТС</div>
            <div>Рег. номер</div>
            <div>Расписание</div>
          </div>
          <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
            {logisticTrips.map((trip, index) => {
              const tripStartTime = getDates.hoursAndMinutes(trip.alarm.time);
              const tripEndTime = getDates.timeAddMinuts(trip.alarm.time, trip.alarm.duration);
              const daysWeekString = getDaysWeekString(trip.alarm.day);

              return (
                <div
                  key={trip.id}
                  className={styles.tripItemTable}
                  style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white", color: trip.alarm.active ? "" : "#08233073" }}
                >
                  {tripCopyPermission ? (
                    <div
                      style={{ color: "black" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onCopyTrip(trip, index);
                      }}
                    >
                      <TooltipWrapper title={`Cкопировать рейс "${trip.title}"`} position="top">
                        <ContentCopyIcon fontSize="small" />
                      </TooltipWrapper>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  <div>{trip.title}</div>
                  <div>{trip.description}</div>
                  <div>{trip.unit !== null ? trip.unit.title : ""}</div>
                  <div>{trip.unit !== null ? trip.unit.registerNumber : ""}</div>
                  <div>{trip.unit !== null ? `${daysWeekString} c ${tripStartTime} по ${tripEndTime}` : ""}</div>

                  <div className={styles.tripTableItemToolpanel}>
                    {tripGetPermission ? (
                      <div
                        onClick={() => {
                          this.onChangeClick(trip);
                        }}
                      >
                        <TooltipWrapper title={`Изменить рейс ${trip.title}`} position="top">
                          <NavLink to={`/logistic/trips/${trip.id}`}>
                            <EditIcon fontSize="small" style={{ color: "black" }} />
                          </NavLink>
                        </TooltipWrapper>
                      </div>
                    ) : (
                      <div></div>
                    )}

                    {tripDeletePermission ? (
                      <div
                        style={{ width: "50px", paddingLeft: "20px", color: "black" }}
                        onClick={(e) => {
                          this.setState({ isDeleteModalOpen: true, deleteTrip: trip });
                        }}
                      >
                        <TooltipWrapper title={`Удалить рейс ${trip.title}`} position="top">
                          <DeleteIcon fontSize="small" />
                        </TooltipWrapper>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              );
            })}
          </Scrollbars>
        </div>

        {deleteTrip !== null ? (
          <ModalConfirmWindow isOpen={isDeleteModalOpen}>
            <DeleteConfirm
              onConfirmHandle={() => {
                this.onDelete(deleteTrip);
                this.setState({ isDeleteModalOpen: false, deleteTrip: null });
              }}
              onNotConfirmHandle={(e) => {
                this.setState({ isDeleteModalOpen: false, deleteTrip: null });
              }}
              text={`Удалить маршрут "${deleteTrip.title}"?`}
            />
          </ModalConfirmWindow>
        ) : null}
      </div>
    );
  }
}

export default withAuth(withLogisticTrips(React.memo(TripsList)));
